export class Loader {
    hide() {
        $('.loading').hide();
    }
    show() {
        $('.loading').show();
    }
}
